import { CustomFieldType } from "../../../graphql/generated";

type CustomFieldDefinitionLike = {
  type: CustomFieldType;
  selectOptions?: { key: string; label: string }[] | null;
};

// Select and multiselect custom fields need their options passed as filter
// values, otherwise the filter dropdown is empty and cannot be used.
export const getCustomFieldFilterOptions = (
  customFieldDefinition: CustomFieldDefinitionLike
): { value: string; label: string }[] | undefined => {
  if (
    customFieldDefinition.type !== CustomFieldType.Select &&
    customFieldDefinition.type !== CustomFieldType.Multiselect
  ) {
    return undefined;
  }
  return (customFieldDefinition.selectOptions || []).map((option) => ({
    value: option.key,
    label: option.label,
  }));
};
